var render = function render(){var _vm=this,_c=_vm._self._c;return _c('admin-wrapper',{attrs:{"title-translation-path":"admin.dataGeneral","subtitle-path":"admin.dataPublicSubtitle","hasButtons":false},scopedSlots:_vm._u([{key:"form",fn:function(){return [_c('admin-tabs-layers',{attrs:{"scope":"core","schema_scope":"core","tab-prop":_vm.tab}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }